import InteractionComponent from '@/app/interaction/ui/interaction-component.vue'

interface CommonOptions {
  title: string | null
  instruction: string | null
}

export function createInteractionComponent<TContent, TState>(id: string, type: string,
                                                             common: CommonOptions,
                                                             content: TContent) {

    const interactionComponent = new InteractionComponent<TContent, TState>({
      propsData: {
        id,
        type,
        content,
        title: common.title,
        instruction: common.instruction
      }
    });

  return interactionComponent
}
